// Brand names come from the API; only the logo needs a local asset lookup, since
// svg-jar assets are bundled by name.
const LOGO_BY_CHANNEL = {
  octave: 'evernorth-logo',
};

export function brandLogoForChannel(channelName) {
  return LOGO_BY_CHANNEL[channelName] ?? null;
}
